import React from 'react';
import './BasicPortfolioNavbar.css';
import logo from '../images/Logo Red.png';

const BasicPortfolioNavbar = ({ onSwitchToInteractive, onOpenContact }) => {
    return (
        <nav className="basic-portfolio-navbar">
            <div className='logo-container'>
                <div className='nav-sphere'>
                    <img src={logo} alt="Logo" className="logo" />
                </div>
            </div>
            <div className='navbar-title'>
                <h1 className="portfolio-title">Edwardt Baum's Portfolio</h1>
            </div>
            <div className='buttons-container'>
                {/* <button 
                    className="nav-button interactive-button"
                    onClick={onSwitchToInteractive}
                >
                    Interactive Experience
                </button> */}
                <button 
                    className="nav-button"
                    onClick={() => window.open('https://www.linkedin.com/in/edwardtbaum/', '_blank', 'noopener,noreferrer')}
                >
                    LinkedIn
                </button>
                <button 
                    className="nav-button"
                    onClick={() => window.open('https://github.com/edwardtsbaum', '_blank', 'noopener,noreferrer')}
                >
                    GitHub
                </button>
                <button 
                    className="nav-button contact-button"
                    onClick={onOpenContact}
                >
                    Contact
                </button>
            </div>
        </nav>
    );
};

export default BasicPortfolioNavbar;
